import { ExpertRole } from "../../experts/types/ExpertRole";

export const handleExpertName = (expertRole: ExpertRole, expertFullName: string) => {
    switch (expertRole) {
      case ExpertRole.Admin:
        return 'Assistenza Clienti';
      default:
        return expertFullName;
    }
  };